/**
 * Grille inscription : nombre total de tableaux × présence d’au moins un tableau
 * « toutes séries » (`fullPrice` côté données, équivalent tableau K).
 * Ne pas confondre avec la majoration post-date (informative sur la Home).
 *
 * Catalogue Stripe partagé par défaut. Si un tournoi définit `pricingTag`,
 * `getPaymentUrl` ne sélectionne que les produits dont
 * `metadata.pricingTag` correspond (voir admin formulaire tournoi).
 *
 * Les tableaux `offert` sont exclus du comptage (gratuit).
 */

import type { Tableau } from "../types/Tableau";

export const PRICE_TIERS_STANDARD = [9, 16, 24, 32, 40] as const;
export const PRICE_TIERS_TOUTES_SERIES = [10, 18, 25, 34, 41] as const;

/** Grille JN Féminisation (règlement) : 8 € / 15 € — hors « toutes séries ». */
export const PRICE_TIERS_JN_FEMINISATION = [8, 15] as const;
export const PRICING_TAG_JN_FEMINISATION = "jn-feminisation-2026";

export function isPayableBoard(
  board: Pick<Tableau, "offert"> | null | undefined
): boolean {
  return board != null && board.offert !== true;
}

export function registrationPriceFromCount(
  nbSelected: number,
  hasToutesSeries: boolean,
  pricingTag?: string | null
): number {
  if (pricingTag === PRICING_TAG_JN_FEMINISATION) {
    if (nbSelected < 1 || nbSelected > PRICE_TIERS_JN_FEMINISATION.length) {
      return 0;
    }
    // Pas de variante « toutes séries » sur cette grille.
    return PRICE_TIERS_JN_FEMINISATION[nbSelected - 1];
  }

  if (nbSelected < 1 || nbSelected > 5) {
    return 0;
  }
  const tiers = hasToutesSeries
    ? PRICE_TIERS_TOUTES_SERIES
    : PRICE_TIERS_STANDARD;
  return tiers[nbSelected - 1];
}

/** Prix à partir d’une liste de tableaux (ignore les `offert`). */
export function registrationPriceFromBoards(
  boards: Array<Pick<Tableau, "offert" | "fullPrice"> | null | undefined>,
  pricingTag?: string | null
): number {
  let nbSelected = 0;
  let hasToutesSeries = false;
  for (const board of boards) {
    if (!isPayableBoard(board)) continue;
    nbSelected++;
    if (board?.fullPrice) {
      hasToutesSeries = true;
    }
  }
  return registrationPriceFromCount(nbSelected, hasToutesSeries, pricingTag);
}
